import { Badge, Price, Text } from "@/components/ui"
import { cn } from "@/lib/cn"

/** One selected option under an item line; `name` may carry a portion fraction, `price` is in reais and hidden when zero. */
export type OrderItemLineOption = {
  key: string
  name: string
  quantityLabel?: string
  price?: number
  note?: string
}

/** Customer notes under an item ("Observações: …"); `size="xs"` is the per-option note. */
export function ItemNote({ note, size = "sm", className }: { note?: string; size?: "sm" | "xs"; className?: string }) {
  if (!note) return null
  return (
    <Text size={size} tone="muted" className={cn("break-words", className)}>
      <Text as="span" weight="semibold">
        Observações:{" "}
      </Text>
      <Text as="span" italic={size === "xs"}>
        {note}
      </Text>
    </Text>
  )
}

/** Options of an item line: quantity badge, name, optional price and per-option note; shared by cart and order rows. */
export function ItemOptionsList({ options, className }: { options: OrderItemLineOption[]; className?: string }) {
  if (options.length === 0) return null
  return (
    <ul className={cn("flex flex-col gap-1", className)}>
      {options.map((option) => (
        <Text as="li" key={option.key} size="sm" tone="muted" className="flex flex-col gap-0.5">
          <span className="flex items-baseline justify-between gap-2">
            <span className="flex min-w-0 items-baseline gap-2">
              {option.quantityLabel ? (
                <Badge size="sm" variant="outline" tone="neutral" className="min-w-5 justify-center">
                  {option.quantityLabel}
                </Badge>
              ) : null}
              <span className="truncate">{option.name}</span>
            </span>
            {option.price !== undefined && option.price > 0 ? <Price value={option.price} /> : null}
          </span>
          <ItemNote note={option.note} size="xs" className={option.quantityLabel ? "ml-7" : undefined} />
        </Text>
      ))}
    </ul>
  )
}
